/** GHA price-validation bot diagnostics — gated on verifier user agent throughout. */

export const GHA_STEPS = [
  { id: 'offer', label: 'Offer' },
  { id: 'mapping', label: 'Property mapping' },
  { id: 'content', label: 'Property content' },
  { id: 'rates', label: 'Rates' },
]

/** True on `/partner/` pages loaded by the GHA price-validation bot. */
export function isGhaVerifier(pathname: string): boolean {
  if (typeof navigator === 'undefined') return false

  return pathname.includes('/partner/') &&
    navigator.userAgent.includes('Google-HotelAdsVerifier')
}

/** `/au/partner/:slug/:offerId` → offerId */
export function getPartnerOfferId(pathname: string): string {
  return pathname.match(/\/partner\/[^/]+\/([^/?#]+)/)?.[1] ?? ''
}

/** Step completion as a stable string like `'1100'` to avoid needless re-renders. */
export function getGhaStepsMask(state: App.State): string {
  const pathname = state.router.location.pathname
  if (!pathname.includes('/partner/')) return ''

  const offerId = getPartnerOfferId(pathname)
  const mapping = state.offer.propertyOfferMappings[offerId]
  const propertyId = mapping?.mapping?.propertyId
  const property = propertyId ? state.offer.properties[propertyId] : undefined
  const rates = Object.values(state.offer.propertyRates)

  return [
    !!state.offer.bedbankOffers[offerId] && !state.offer.offersLoading[offerId],
    !!mapping?.mapping && !mapping.fetching,
    !!property?.property && !property.fetching,
    rates.length > 0 && rates.every(rate => rate !== undefined && !rate.fetching),
  ].map(Number).join('')
}

export function elapsedMs(): number {
  return typeof performance !== 'undefined' ? performance.now() : 0
}

/** e.g. `0:03.45` */
export function formatElapsed(ms: number): string {
  const seconds = Math.max(0, ms) / 1000
  const [whole, fraction = '00'] = (seconds % 60).toFixed(2).split('.')

  return `${Math.floor(seconds / 60)}:${whole.padStart(2, '0')}.${fraction}`
}
